/**
 * Session Manager - Handles cart sessionId storage in cookies
 */

const SESSION_COOKIE_NAME = 'mystic_prana_session_id';
const SESSION_COOKIE_EXPIRY_DAYS = 7; // Session expires after 7 days

/**
 * Generate a unique session ID
 */
const generateSessionId = () => {
  return `session_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
};

/**
 * Set a cookie with expiration
 */
const setCookie = (name, value, days) => {
  const date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  const expires = `expires=${date.toUTCString()}`;
  document.cookie = `${name}=${value};${expires};path=/`;
  console.log(`[Session] Set cookie: ${name} = ${value}, expires in ${days} days`);
};

/**
 * Get a cookie value by name
 */
const getCookie = (name) => {
  const nameEQ = name + '=';
  const cookies = document.cookie.split(';');
  
  for (let cookie of cookies) {
    cookie = cookie.trim();
    if (cookie.indexOf(nameEQ) === 0) {
      const value = cookie.substring(nameEQ.length);
      console.log(`[Session] Retrieved cookie: ${name} = ${value}`);
      return value;
    }
  }
  
  console.log(`[Session] Cookie not found: ${name}`);
  return null;
};

/**
 * Delete a cookie
 */
const deleteCookie = (name) => {
  document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/`;
  console.log(`[Session] Deleted cookie: ${name}`);
};

/**
 * Get or create session ID
 */
export const getOrCreateSessionId = () => {
  let sessionId = getCookie(SESSION_COOKIE_NAME);
  
  if (!sessionId) {
    // Generate new session ID if not found
    sessionId = generateSessionId();
    setCookie(SESSION_COOKIE_NAME, sessionId, SESSION_COOKIE_EXPIRY_DAYS);
    console.log(`[Session] Created new session: ${sessionId}`);
  } else {
    console.log(`[Session] Using existing session: ${sessionId}`);
  }
  
  return sessionId;
};

/**
 * Refresh session expiry (extend the cookie lifetime)
 */
export const refreshSessionExpiry = () => {
  const sessionId = getCookie(SESSION_COOKIE_NAME);
  if (sessionId) {
    setCookie(SESSION_COOKIE_NAME, sessionId, SESSION_COOKIE_EXPIRY_DAYS);
    console.log(`[Session] Refreshed session expiry: ${sessionId}`);
  }
};

/**
 * Clear session (logout)
 */
export const clearSession = () => {
  deleteCookie(SESSION_COOKIE_NAME);
  console.log(`[Session] Session cleared`);
};

/**
 * Get session info for debugging
 */
export const getSessionInfo = () => {
  const sessionId = getCookie(SESSION_COOKIE_NAME);
  return {
    sessionId: sessionId || 'none',
    exists: !!sessionId,
    cookieName: SESSION_COOKIE_NAME,
    expiryDays: SESSION_COOKIE_EXPIRY_DAYS,
  };
};

export default {
  getOrCreateSessionId,
  refreshSessionExpiry,
  clearSession,
  getSessionInfo,
};
